import { WorksheetImagesAndRemarksSection, WorksheetTestedBySection } from 'Components/Worksheets/Core';
import { ListFieldSection, PageSection, SectionGroup } from '../../../Layout';
import ids from '../../QestIds';

import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import {
  CompactionCwdSection,
  CompactionDataSection,
  CompactionEquipmentSection,
  CompactionWaterContentDeterminationEquipmentSection,
} from '../Shared';
import {
  CompactionWaterContentDeterminationGridSection,
  OversizeCorrectionSection,
  OversizeDeterminationSection,
  PreparationSection,
  ResultsSection,
} from './Sections';

const qestIds = [ids.maximumDryDensity.ARIZ_225d_245c.rev2019];

let ArizMddWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PreparationSection />
      <OversizeDeterminationSection />
      <NamePrefixModifier appendNamePrefix="Preparation.SpecificGravityCoarse">
        <OversizeCorrectionSection />
      </NamePrefixModifier>

      <PageSection heading="Compaction">
        <CompactionEquipmentSection />
        <SectionGroup heading="Compaction Data">
          <CompactionCwdSection />
          <ListFieldSection name="TestPortions" />
          <CompactionDataSection />
        </SectionGroup>
        <SectionGroup heading="Moisture Content Determination">
          <CompactionWaterContentDeterminationEquipmentSection />
          <CompactionWaterContentDeterminationGridSection />
        </SectionGroup>
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSection />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

ArizMddWorksheet.qestIds = qestIds;

export default ArizMddWorksheet;
